/**
 * 심볼별 포지션/주문 맵의 표시 카운트 (dep-free 순수 모듈).
 * - Show all: 전체 심볼 합산
 * - 아니면: 현재 심볼의 개수만
 * 헤더 탭 뱃지 카운트 계산에 사용한다.
 */
export const countBySymbolFilter = (
  positionsBySymbol: Record<string, unknown[]> | null | undefined,
  { symbol, showAllSymbol }: { symbol: string; showAllSymbol: boolean },
): number => {
  if (!positionsBySymbol) return 0;
  if (!showAllSymbol) return positionsBySymbol[symbol]?.length ?? 0;
  return Object.values(positionsBySymbol).reduce((totalCount, positions) => totalCount + positions.length, 0);
};
